import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const retryDispatchRecordMutationAtom = createMutationAtomFactory(
  'settings.dispatchRecordRetry',
  ({ id }: { id: string }) => ({
    complianceComplianceDispatchRecordRetry: {
      __args: {
        id,
      },
      id: true,
      status: true,
    },
  }),
);
